module.exports = __webpack_public_path__ + "img/exclamation_mark.db625b32.svg";